var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEuro = function SvgEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#258FE4",
    d: "M14.774 9.314A7.498 7.498 0 1 1 .224 5.686a7.498 7.498 0 0 1 14.55 3.628"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F3F5",
    d: "M8.882 10.5a2.88 2.88 0 0 1-1.925-.75h1.925v-1.5H6.045a3 3 0 0 1-.104-.75h3.676V6H6.35c.51-.893 1.448-1.5 2.532-1.5.81 0 1.546.337 2.078.88L12 4.32A4.36 4.36 0 0 0 8.882 3C6.965 3 5.335 4.255 4.728 6H3v1.5h1.47c0 .256.026.505.067.75H3v1.5h2.067C5.831 11.092 7.253 12 8.882 12A4.36 4.36 0 0 0 12 10.68l-1.039-1.059a2.9 2.9 0 0 1-2.08.879"
  })));
};
export default SvgEuro;